import type { KpiRowBlock } from "@/types/blocks";

const DELTA_TONE = {
  neutral: "text-muted-foreground",
  positive: "text-success",
  negative: "text-destructive",
} as const;

/** A row of stat tiles. Values are pre-formatted server-side. */
export function KpiRowBlockView({ block }: { block: KpiRowBlock }) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {block.items.map((item, i) => (
        <div key={i} className="flex flex-col gap-1 rounded-md border border-border bg-card p-3">
          <span className="text-xs text-muted-foreground">{item.label}</span>
          <span className="text-lg font-semibold text-foreground tabular-nums">{item.value}</span>
          {item.delta && (
            <span className={`text-xs ${DELTA_TONE[item.tone]}`}>{item.delta}</span>
          )}
        </div>
      ))}
    </div>
  );
}
